import ReportBugModal from './reportBugModal'

export default ReportBugModal